// When did this device first open Pleasant? (PLE-13, Sep 2026)
//
// Used so a brand-new install isn't greeted by an old "what's new" notice
// that was written for people who already had the app. Recorded once, at
// boot, BEFORE onboarding runs — so an existing profile at that moment means
// the device was already using Pleasant before this key existed, and it is
// stamped 0 ("always been here": sees every notice, exactly as before).
//
// Never throws: storage failures fall back to 0, which means "show notices"
// — the old behaviour, never a lost outage warning.

const KEY = "pleasant.firstOpenAt.v1";

const EXISTING_INSTALL_KEYS = [
  "pleasant.profile.v2",
  "pleasant.profile.v1",
  "pleasant.introSeen.v1",
  "pleasant.notice.dismissed",
];

/** Stamp the first-open time if it isn't there yet. Call once at boot. */
export function recordFirstOpen(): void {
  try {
    if (localStorage.getItem(KEY) !== null) return;
    const existing = EXISTING_INSTALL_KEYS.some((k) => localStorage.getItem(k) !== null);
    localStorage.setItem(KEY, existing ? "0" : String(Date.now()));
  } catch { /* storage unavailable — treated as 0 below */ }
}

/** Milliseconds since epoch of first open; 0 for pre-existing installs or unknown. */
export function firstOpenAt(): number {
  try {
    const n = Number(localStorage.getItem(KEY));
    return Number.isFinite(n) && n > 0 ? n : 0;
  } catch {
    return 0;
  }
}
